/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ events: NonNullable<unknown> }} Authorized_Apps_For_EventsInputs */



/**
* | output |
* | --- |
* | "Events: {events}" |
*
* @param {Authorized_Apps_For_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const authorized_apps_for_events = /** @type {((inputs: Authorized_Apps_For_EventsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authorized_Apps_For_EventsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événements : ${i?.events}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Eventos: ${i?.events}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Eventos: ${i?.events}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eventi: ${i?.events}`)
	return /** @type {LocalizedString} */ (`Events: ${i?.events}`)
});